<div class="inicio">

    <p>
        SEGUIMIENTO DE LA ASIGNACIÓN DE EQUIPOS
        <button mat-mini-fab color="primary" (click)="clickMasInformacion($event)"
            matTooltip="Click para más información"><mat-icon>info</mat-icon></button>
    </p>

    <div class="grid-container2">
        <mat-form-field>
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="filtroDataDource($event)"
                placeholder="Ingrese el nombre del empleado, cargo u oficina a buscar"
                oninput="this.value = this.value.toUpperCase()">
        </mat-form-field>
    </div>
    <mat-progress-bar *ngIf="expression" mode="indeterminate"></mat-progress-bar>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="NOTIFICACION">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.total_asignaciones > 0" style="color: #f44336;">fiber_manual_record</mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="OPCIONES">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-mini-fab color="accent" (click)="clickRegistros(element.id_empleado)"
                    matTooltip="Click para ver los equipos asignados a este empleado"> <mat-icon>visibility</mat-icon>
                </button>
            </td>
        </ng-container>


        <ng-container matColumnDef="NOMBRE DEL COLABORADDOR">
            <th mat-header-cell *matHeaderCellDef> NOMBRE DEL COLABORADOR </th>
            <td mat-cell *matCellDef="let element">{{element.nombre}}</td>
        </ng-container>

        <ng-container matColumnDef="CARGO">
            <th mat-header-cell *matHeaderCellDef> CARGO </th>
            <td mat-cell *matCellDef="let element"> {{element.puesto || 'NA'}} </td>
        </ng-container>

        <ng-container matColumnDef="OFICINA">
            <th mat-header-cell *matHeaderCellDef> OFICINA </th>
            <td mat-cell *matCellDef="let element"> {{element.sucursal}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
        <tr mat-row *matRowDef="let row; columns: encabezados;"></tr>
    </table>

    <mat-paginator #paginator class="mat-elevation-z8" [pageSizeOptions]="[5,20, 50, 100]"
        showFirstLastButtons></mat-paginator>
</div>